import { Link } from 'react-router-dom';
import MetaTags from '@/components/MetaTags';
import { PAGE_META_DATA } from '@/constants/constants';

function UserAndAuthorTerms() {
  return (
    <div className='container mx-auto p-4 sm:px-0'>
      <MetaTags
        title={PAGE_META_DATA.userAndAuthorTerms.title}
        description={PAGE_META_DATA.userAndAuthorTerms.description}
      />

      <h3>TERMS AND CONDITIONS BETWEEN RESEARCH PROVIDER AND END USER</h3>
      <p>
        PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY BEFORE PURCHASING ANY RESEARCH MATERIALS FROM A RESEARCH
        PROVIDER ON THE EKLIPX RESEARCH PLATFORM <br />
        BACKGROUND <br />
        (A) You have opened an account on a platform (the “eklipX Research Platform”) owned and operated by eklipX
        Limited, being a company incorporated in England with company number 14950181 and having its registered office
        at 1H Eardley Crescent, London, United Kingdom, SW5 9JS and having its business office at 14 Hayes Mews, London,
        United Kingdom, WIJ 5PT (referred to in these terms as “eklipX”); <br />
        (2) The eklipX Research Platform enables you (as an end user) to purchase articles, podcasts and other types of
        media related to financial services (the “Research Materials”) from persons (the “Research Providers”) which
        make the Research Materials available to be purchased on the eklipX Research Platform. <br />
        (B) When you purchase a Research Material on the eklipX Research Platform, you are purchasing the Research
        Material from the Research Provider. This document sets out the terms and conditions between the Research
        Provider and you (as end user) in relation to the Research Materials which you purchase. <br />
        AGREED TERMS
      </p>
      <ol className='list-decimal [counter-reset:section] mt-4'>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Accepting these terms
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You require an account on the eklipX Research Platform to purchase a licence of Research Material on the
            eklipX Research Platform. Please see the terms between eklipX and you (available here [insert weblink to
            these terms]) for more information.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            By agreeing to purchase a licence for Research Materials on the eklipX Research Platform, you will be deemed
            to have accepted these terms.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You should not agree to purchase a licence for Research Materials if you do not agree to these terms.
          </li>
        </ol>

        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Terms of the purchase of each Research Material
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You will be granted a licence, as licensee, to use the Research Material as set out in clause 7.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The licensor of the Research Material will be the Research Provider listed as the licensor of the relevant
            Research Material on the eklipX Research Platform. We shall refer to the licensor of the Research Material
            that you have agreed to purchase as “we”, “us” and “our” in the remainder of these terms.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Once you have agreed to purchase a licence of Research Material from us on the eklipX Research Platform, it
            will be made available for you on the eklipX Research Platform.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The purchased Research Material will remain accessible to you on eklipX Research Platform for 60 days from
            and including the date of purchase.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            For the avoidance of any doubt, the parties acknowledge that eklipX: <br />
            (a) is acting as a delivery channel through which Research Material is supplied; <br />
            (b) is acting as the Research Provider’s agent in concluding the contract between you and us and in
            accepting payment from you on our behalf (receipt of money by eklipX for orders and subscriptions will (as
            far as you are concerned) be deemed to be receipt of money from us); <br />
            (c) does not assume any responsibility arising out of, or in connection with, this contract.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Order and Subscription Model
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You can either: <br />
            (a) purchase one-off Research Materials from us at the list price noted for that Research Material on the
            eklipX Research Platform; or <br />
            (b) subscribe to our Research Materials by clicking the ‘subscribe’ button beside our profile on the eklipX
            Research Platform.{' '}
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If you choose to subscribe to us we will, in turn for the agreed periodic list price, make available to you
            on the eklipX Research Platform a number of Research Materials for that time period and each subsequent time
            period until you cancel your subscription.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Error when purchasing Research Materials
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We do not accept any liability in relation to errors made by you when purchasing Research Material. This
            includes, but is not limited to, cases where you purchase the wrong Research Material or the wrong type of
            Research Material.{' '}
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Once the Research Material is purchased, it is not possible to cancel the purchase of any Research Material
            or to exchange one Research Material for another.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Error when viewing the purchased Research Material
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If there is an error with the eklipX Research Platform and you cannot view the purchased Research Material
            you should contact the eklipX team immediately at support@eklipx.io
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You must include a summary of the problem (and photographic evidence if possible) in your email to the
            eklipX team.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            The eklipX team will then find an alternative way to allow you to view the Research Material.{' '}
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            More information surrounding ways in which the eklipX team may grant you access to the Research Material if
            a problem with the eklipX Research Platform occurs can be found in the{' '}
            <Link to='terms'>Terms between eklipX and End Users</Link>.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
          <span className='font-semibold'>We are not responsible for translated Research Materials</span> <br />
          You may be able to view or hear the Research Material in a language other than its original language through a
          translation service. However, the original version is the true version. Any translation done (by you, us,
          eklipX or a third party) is done at your own risk. We are not responsible for any losses you incur as a result
          of the Research Material in its original language being translated into a different language.
        </li>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          How you may use Purchased Research Materials
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We are the owner or licensee of the intellectual property rights in the Research Material which you have
            licensed from us. The Research Material is protected by copyright laws and treaties around the world. All
            such rights are reserved.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You must not modify the Research Material in any material way, and you must not use any illustrations,
            photographs, video or audio sequences or any graphics separately from any accompanying text.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We may request that you return or destroy any copies of my Research Material which you have modified.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Our status as the author of the Research Material must always be acknowledged.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            You must not use my Research Material for commercial purpose without first obtaining a licence to do so from
            us or (as relevant) our licensors.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Our responsibility to you
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We do not exclude or limit in any way our liability to you where it would be unlawful to do so. This
            includes liability for death or personal injury caused by our negligence and for fraud or fraudulent
            misrepresentation.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            We will not be liable for any: <br />
            (a) loss of profits, sales, business, or revenue; <br />
            (b) loss of anticipated savings; <br />
            (c) loss resulting from trading; <br />
            (d) loss of business opportunity, goodwill or reputation; or <br />
            (e) any indirect or consequential loss or damage. <br />
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
          <span className='font-semibold'>How we may use your personal information</span> <br />
          We will only use your personal information as set out in our privacy policy which you can obtain from eklipX
          upon request or from our profile on the eklipX Research Platform.
        </li>

        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          Which country&apos;s laws apply to any disputes?
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Please note that these terms of use, their subject matter and their formation, are governed by the laws of
            England and Wales. You and we both agree that the courts of England and Wales will have exclusive
            jurisdiction except that, if you are a resident of Northern Ireland you may also bring proceedings in
            Northern Ireland, and if you are resident of Scotland, you may also bring proceedings in Scotland.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If you are a business, these terms of use, their subject matter and their formation (and any non-contractual
            disputes or claims) are governed by the law of England and Wales. You and I both agree to the exclusive
            jurisdiction of the courts of England and Wales.
          </li>
        </ol>
        <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2 font-semibold">
          General
        </li>
        <ol className='list-decimal [counter-reset:section] ps-4'>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            If any part, term or provision of these terms of use is held to be illegal, invalid or otherwise
            unenforceable, the validity or enforceability of the remainder of these terms of use shall not be affected.
            Any failure or delay on our part to exercise or enforce any right in these terms of use does not waive my
            right to enforce such right.
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Notwithstanding anything to the contrary contained in these terms of use, they shall not operate to confer
            any rights or benefits on any third parties.{' '}
          </li>
          <li className="[counter-increment:section] marker:[content:counters(section,'.')] ps-2">
            Nothing in these terms shall create, or be deemed to create a partnership or the relationship of principal
            and agent between you and us.
          </li>
        </ol>
      </ol>
    </div>
  );
}

export default UserAndAuthorTerms;
